const SkeletonBlock = ({ className = "" }) => <span className={`skeleton-block ${className}`} />;

export default function LoadingSkeleton() {
  return (
    <div className="page-stack" aria-label="Loading dashboard">
      <section className="dashboard-hero skeleton-panel">
        <div>
          <SkeletonBlock className="w-120" />
          <SkeletonBlock className="w-320 h-48" />
          <SkeletonBlock className="w-220" />
        </div>
        <div className="hero-metric-grid">
          <SkeletonBlock className="h-112" />
          <SkeletonBlock className="h-112" />
          <SkeletonBlock className="h-112" />
        </div>
      </section>
      <section className="kpi-grid">
        {Array.from({ length: 4 }).map((_, index) => (
          <article className="kpi-card skeleton-panel" key={index}>
            <SkeletonBlock className="w-80" />
            <SkeletonBlock className="w-160 h-32" />
            <SkeletonBlock className="w-120" />
          </article>
        ))}
      </section>
      <section className="analytics-grid">
        <div className="panel skeleton-panel">
          <SkeletonBlock className="w-180" />
          <SkeletonBlock className="h-240" />
        </div>
        <div className="panel skeleton-panel">
          <SkeletonBlock className="w-180" />
          <SkeletonBlock className="h-240" />
        </div>
      </section>
    </div>
  );
}
